import { gql } from '@apollo/client';

export const FETCH_SIGN_NOW_ENVELOPE_STATUS = gql`
  mutation Flex_FetchSignNowEnvelopeStatus($id: Int!) {
    fetchSignNowEnvelopeStatus(id: $id) {
      id
      status
      signingUrl
    }
  }
`;
